export default __webpack_public_path__ + "static/media/LandingPage.f0d89c0e.png";